<template>
  <div class="home-gerais">
    <mf-loading-dialog :loading="$apollo.loading">
      <v-container class="pa-0" fluid>
        <v-card class="my-3 px-6">
          <v-card-title class="d-flex justify-space-between">
            <span class="section-title">Módulos</span>
            <mf-button label="Ver documentação" icon="open_in_new" icon-position="right" color="marca-0-l40" @click="redirectToDoc" />
          </v-card-title>
          <v-card-text>
            <v-container fluic class="pa-0">
              <v-row>
                <v-col v-for="(value, key) in localModules" :key="key" cols="3">
                  <v-checkbox v-model="localModules[key]" :label="key" hide-details single-line color="primary" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0 pr-3">
            <v-spacer />
            <mf-button label="Atualizar módulos" :loading="saving" @click="updateModules" />
          </v-card-actions>
        </v-card>

        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">Whatsapp</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="pa-0 pl-3" cols="4">
                <v-checkbox v-model="whatsapp.active" label="Ativo" hide-details single-line color="primary" />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Máximo de disparadores</label>
                <v-text-field v-model="whatsapp.max_nof_senders" v-mask="'######'" class="mb-0" :disabled="!whatsapp.active" outlined />
              </v-col>
              <v-spacer />
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Máximo de contatos</label>
                <v-text-field v-model="whatsapp.max_nof_contacts" v-mask="'######'" class="mb-0" :disabled="!whatsapp.active" outlined />
              </v-col>
              <v-spacer />
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Máximo de mensagens diárias</label>
                <v-text-field v-model="whatsapp.max_nof_messages" v-mask="'######'" class="mb-0" :disabled="!whatsapp.active" outlined />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0 pr-3">
            <v-spacer />
            <mf-button label="Atualizar whatsapp" :loading="saving" @click="updateWhatsapp" />
          </v-card-actions>
        </v-card>

        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">Email</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Conta da Infobip</label>
                <v-text-field v-model="email.credentials.login" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Senha da Infobip</label>
                <v-text-field v-model="email.credentials.password" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col cols="3"> </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="pt-3" cols="3">
                <label class="detail-title">E-mail do remetente</label>
                <v-text-field v-model="email.domain" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col class="pt-3" cols="3">
                <label class="detail-title">Nome do Remetente</label>
                <v-text-field v-model="email.sender_name" class="mb-0" outlined />
              </v-col>
              <v-col class="pt-3" cols="3">
                <mf-button outlined label="Enviar E-mail de teste" :loading="sendingTestEmail" @click="showTestEmail = true" />
              </v-col>
              <v-spacer />
            </v-row>
            <v-row>
              <v-col class="pt-3" cols="3">
                <label class="detail-title">Preço do crédito</label>
                <v-text-field v-model="email.price" class="mb-0" outlined prefix="R$" suffix="/crédito" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0 pr-3">
            <v-spacer />
            <mf-button label="Atualizar e-mail" :loading="saving" @click="updateEmail" />
          </v-card-actions>
        </v-card>

        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">SMS</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Login</label>
                <v-text-field v-model="sms.credentials.login" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Senha</label>
                <v-text-field v-model="sms.credentials.password" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col cols="3" class="pt-6">
                <label class="detail-title">Fornecedor</label>
                <v-select v-model="sms.credentials.provider" :items="smsProviders" outlined hide-details />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-3" cols="3">
                <label class="detail-title">Preço do crédito</label>
                <v-text-field v-model="sms.price" class="mb-0" outlined prefix="R$" suffix="/crédito" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0 pr-3">
            <v-spacer />
            <mf-button label="Atualizar SMS" :loading="saving" @click="updateSms" />
          </v-card-actions>
        </v-card>

        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">SMS de recuperação de senha</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Login</label>
                <v-text-field v-model="password_recovery_sms.credentials.login" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col class="pt-6" cols="3">
                <label class="detail-title">Senha</label>
                <v-text-field v-model="password_recovery_sms.credentials.password" class="mb-0" outlined />
              </v-col>
              <v-spacer />
              <v-col cols="3" class="pt-6">
                <label class="detail-title">Fornecedor</label>
                <v-select v-model="password_recovery_sms.credentials.provider" :items="smsProviders" outlined hide-details />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-3" cols="3">
                <label class="detail-title">Preço do crédito</label>
                <v-text-field v-model="password_recovery_sms.price" class="mb-0" outlined prefix="R$" suffix="/crédito" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0 pr-3">
            <v-spacer />
            <mf-button label="Atualizar SMS de recuperação de senha" :loading="saving" @click="updatePasswordRecoverySms" />
          </v-card-actions>
        </v-card>
      </v-container>
      <test-email v-if="showTestEmail" v-model="showTestEmail" :credentials="email.credentials" :domain="email.domain" :sender-name="email.sender_name" />
    </mf-loading-dialog>
  </div>
</template>

<script>
import { VMoney } from 'v-money'
import gql from 'graphql-tag'
import { modules } from '@/config'
import { cloneDeep } from 'lodash'
import { deepDelete } from '@/helpers/deepDelete'

const DEFAULT_EMAIL_PRICE = 0.0035
const DEFAULT_SMS_PRICE = 0.07
const DEFAULT_PASSWORD_RECOVERY_SMS_PRICE = 0.13

const QUERY_ACCOUNT = gql`
  query Account {
    account {
      modules
      prices {
        credits {
          sms
          email
        }
      }
      summaries {
        force_all_campaigns_update
        force_all_offers_schedules_update
      }
      sms_credentials {
        login
        password
        provider
      }
      password_recovery_sms_credentials {
        login
        password
        provider
      }
      email_credentials {
        login
        password
      }
      channels {
        whatsapp {
          active
          max_nof_senders
          max_nof_contacts
          max_nof_messages
        }
        email {
          domain
          sender_name
        }
      }
    }
  }
`
const MUTATION_MODULES = gql`
  mutation UpdateModules($allowed: [String]!, $disallowed: [String]!) {
    updateAccountModules(allowed: $allowed, disallowed: $disallowed)
  }
`

const MUTATION_WHATSAPP = gql`
  mutation UpdateWhatsapp($active: Boolean, $max_nof_senders: Int, $max_nof_contacts: Int, $max_nof_messages: Int) {
    updateAccountWhatsapp(active: $active, max_nof_senders: $max_nof_senders, max_nof_contacts: $max_nof_contacts, max_nof_messages: $max_nof_messages)
  }
`

const MUTATION_EMAIL = gql`
  mutation UpdateEmail($credentials: BasicCredentialInput, $domain: String, $sender_name: String, $price: Float) {
    updateAccountEmail(credentials: $credentials, domain: $domain, sender_name: $sender_name, price: $price)
  }
`

const MUTATION_SMS = gql`
  mutation UpdateSMS($credentials: BasicCredentialInput, $price: Float) {
    updateAccountSMS(credentials: $credentials, price: $price)
  }
`

const MUTATION_PASSWORD_RECOVERY_SMS = gql`
  mutation UpdatePasswordRecoverySMS($credentials: BasicCredentialInput, $price: Float) {
    updateAccountPasswordRecoverySMS(credentials: $credentials, price: $price)
  }
`

export default {
  components: {
    TestEmail: () => import('@/modules/configuracoes-admin/views/components/TestEmail.vue'),
  },
  directives: { money: VMoney },
  data: () => ({
    saving: false,
    sendingTestEmail: false,
    showTestEmail: false,
    sms: {
      credentials: {
        login: '',
        password: '',
        provider: '',
      },
    },
    password_recovery_sms: {
      credentials: {
        login: '',
        password: '',
        provider: '',
      },
    },
    email: {
      credentials: {
        login: '',
        password: '',
      },
      domain: '',
      sender_name: '',
    },
    whatsapp: {
      active: false,
      max_nof_senders: 0,
      max_nof_contacts: 0,
      max_nof_messages: 0,
    },
  }),
  computed: {
    localModules() {
      return cloneDeep(modules)
    },
    smsProviders() {
      return [
        { text: 'Infobip', value: 'infobip' },
        { text: 'YupChat', value: 'yup' },
        { text: 'YupChat v2', value: 'yup_v2' },
      ]
    },
    costInputConfigs() {
      return { decimal: ',', thousands: '.', prefix: 'R$ ', precision: 3 }
    },
  },
  apollo: {
    account: {
      query: QUERY_ACCOUNT,
      fetchPolicy: 'no-cache',
      update({ account }) {
        if (!account) return {}

        // Set modules
        const accountModules = account?.modules || []
        Object.entries(accountModules).forEach(([mdl, enabled]) => (this.localModules[mdl] = enabled))

        // Set whatsapp
        this.whatsapp.active = Boolean(account?.channels?.whatsapp?.active)
        this.whatsapp.max_nof_senders = account?.channels?.whatsapp?.max_nof_senders || 0
        this.whatsapp.max_nof_contacts = account?.channels?.whatsapp?.max_nof_contacts || 0
        this.whatsapp.max_nof_messages = account?.channels?.whatsapp?.max_nof_messages || 0

        // Set Email
        this.email.credentials = account?.email_credentials || account?.sms_credentials || this.email.credentials
        this.email.domain = account?.channels?.email?.domain
        this.email.sender_name = account?.channels?.email?.sender_name
        this.email.price = Number.parseFloat(account?.prices?.credits?.email || DEFAULT_EMAIL_PRICE)
          .toPrecision(2)
          .replace('.', ',')

        // Set SMS
        this.sms.credentials = account?.sms_credentials || this.sms.credentials
        this.sms.credentials.provider = this.sms.credentials.provider || 'infobip'
        this.sms.price = Number.parseFloat(account?.prices?.credits?.sms || DEFAULT_SMS_PRICE)
          .toPrecision(2)
          .replace('.', ',')

        // Set SMS
        this.password_recovery_sms.credentials = account?.password_recovery_sms_credentials || this.password_recovery_sms.credentials
        this.password_recovery_sms.credentials.provider = this.password_recovery_sms.credentials.provider || 'infobip'
        this.password_recovery_sms.price = Number.parseFloat(account?.prices?.credits?.password_recovery_sms || DEFAULT_PASSWORD_RECOVERY_SMS_PRICE)
          .toPrecision(2)
          .replace('.', ',')

        return account
      },
      notifyOnNetworkStatusChange: true,
    },
  },
  mounted() {
    document.title = 'Configurações Gerais'
  },
  methods: {
    redirectToDoc() {
      const routeURL = 'https://mercafacil.getoutline.com/s/148425e5-63cc-4441-8678-28175da5f90f'
      window.open(routeURL, '_blank')
    },
    parseMoney(value) {
      return parseFloat(value.replace('R$ ', '').replace(',', '.'))
    },
    async updateEmail() {
      const confirmed = await this.$confirm({
        title: 'Atualizar configurações',
        message: 'Tem certeza que deseja atualizar as configurações de E-mail?',
        confirmText: 'Salvar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.saving = true
      deepDelete(this.email.credentials, '__typename')
      await this.$apollo.mutate({
        mutation: MUTATION_EMAIL,
        variables: {
          credentials: this.email.credentials,
          domain: this.email.domain,
          sender_name: this.email.sender_name,
          price: this.parseMoney(this.email.price),
        },
      })
      this.saving = false
      this.$apollo.queries.account.refresh()
    },
    async updateSms() {
      const confirmed = await this.$confirm({
        title: 'Atualizar configurações',
        message: 'Tem certeza que deseja atualizar as configurações de SMS?',
        confirmText: 'Salvar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.saving = true
      deepDelete(this.sms.credentials, '__typename')
      await this.$apollo.mutate({
        mutation: MUTATION_SMS,
        variables: {
          credentials: this.sms.credentials,
          price: this.parseMoney(this.sms.price),
        },
      })
      this.saving = false
      this.$apollo.queries.account.refresh()
    },
    async updatePasswordRecoverySms() {
      const confirmed = await this.$confirm({
        title: 'Atualizar configurações',
        message: 'Tem certeza que deseja atualizar as configurações de SMS para recuperação de senha?',
        confirmText: 'Salvar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.saving = true
      deepDelete(this.password_recovery_sms.credentials, '__typename')
      await this.$apollo.mutate({
        mutation: MUTATION_PASSWORD_RECOVERY_SMS,
        variables: {
          credentials: this.password_recovery_sms.credentials,
          price: this.parseMoney(this.password_recovery_sms.price),
        },
      })
      this.saving = false
      this.$apollo.queries.account.refresh()
    },
    async updateWhatsapp() {
      const confirmed = await this.$confirm({
        title: 'Atualizar configurações',
        message: 'Tem certeza que deseja atualizar as configurações de Whatsapp?',
        confirmText: 'Salvar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.saving = true
      await this.$apollo.mutate({
        mutation: MUTATION_WHATSAPP,
        variables: {
          active: this.whatsapp.active,
          max_nof_senders: parseInt(this.whatsapp.max_nof_senders),
          max_nof_contacts: parseInt(this.whatsapp.max_nof_contacts),
          max_nof_messages: parseInt(this.whatsapp.max_nof_messages),
        },
      })
      this.saving = false
      this.$apollo.queries.account.refresh()
    },
    async updateModules() {
      const confirmed = await this.$confirm({
        title: 'Atualizar módulos',
        message: 'Atualizar os módulos sobrescreve a configuração anterior de módulos. Tem certeza que deseja salvar?',
        confirmText: 'Salvar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.saving = true
      await this.$apollo.mutate({
        mutation: MUTATION_MODULES,
        variables: {
          allowed: Object.entries(this.localModules).reduce((acc, [mdl, value]) => (value ? [...acc, mdl] : acc), []),
          disallowed: Object.entries(this.localModules).reduce((acc, [mdl, value]) => (!value ? [...acc, mdl] : acc), []),
        },
      })
      this.saving = false
      this.$setAllowedModules(this.localModules)
      this.$apollo.queries.account.refresh()
    },
  },
}
</script>

<style lang="scss">
.home-gerais {
  .section-title {
    font-size: 20px;
    font-weight: bold;
  }
  .detail-title {
    opacity: 0.8;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: 0.24px;
    color: $preto;
    margin-bottom: 8px;
  }
  .redirect-docs-button {
    border-radius: 8px;
    color: $branco;
  }
}
</style>
